// criterioOptimizacion.js — P3-9b. Decide si una foto EXISTENTE conviene
// reprocesar, con los números REALES medidos (dimensiones del original + peso del
// JPG resultante de pasarla por la tubería). Frontend-only → export ES (el build
// caza el mismatch CJS/ESM). Puro.
//
// Criterio (Miguel, 1-nov-2026): reprocesar si la foto está SOBREDIMENSIONADA
// (más de 1600×2000) O si el JPG resultante pesa AL MENOS 30% menos que el
// original. Si no cumple ninguna, se deja como está. El censo de la Fase A es una
// COTA; el 30% de verdad sale de reprocesar y medir (esto recibe ese número).

export const TECHO_W = 1600;
export const TECHO_H = 2000;
export const UMBRAL_AHORRO = 0.30; // 30% más liviana

// P3-12: el techo depende de la PROPORCIÓN del tipo (4:5→1600×2000, 1:1→1600×1600, 3:4→1600×2133).
// Defaults 4:5 (la prenda no cambia); el caller pasa techoW/techoH de la proporción del producto.
export function estaSobredimensionada(ancho, alto, { techoW = TECHO_W, techoH = TECHO_H } = {}) {
  return (Number(ancho) > techoW) || (Number(alto) > techoH);
}

// { ancho, alto, pesoOriginal, pesoNuevo, techoW, techoH } (pesos en bytes)
// → { reprocesar, motivo, ahorroPct, ahorroBytes }
// motivo: 'sobredimensionada' (gana si aplica) | 'mas-liviana' | 'no'.
// ahorroPct/ahorroBytes: 0 si no hay ahorro (o la nueva pesa más) — nunca negativo.
export function decidirReproceso({ ancho, alto, pesoOriginal, pesoNuevo, techoW = TECHO_W, techoH = TECHO_H } = {}) {
  const orig = Number(pesoOriginal) || 0;
  const nuevo = Number(pesoNuevo) || 0;
  const ahorroBytes = orig > 0 && nuevo > 0 ? Math.max(0, orig - nuevo) : 0;
  const ahorroPct = orig > 0 ? ahorroBytes / orig : 0;
  const sobre = estaSobredimensionada(ancho, alto, { techoW, techoH });
  const masLiviana = orig > 0 && nuevo > 0 && nuevo <= orig * (1 - UMBRAL_AHORRO);
  let motivo = 'no';
  if (sobre) motivo = 'sobredimensionada';
  else if (masLiviana) motivo = 'mas-liviana';
  return { reprocesar: sobre || masLiviana, motivo, ahorroPct, ahorroBytes };
}
